import { createSlice } from "@reduxjs/toolkit";
import React from "react";

const initialState = {
  infoAfiliado: {
    codigoAfiliado: null,
    nombres: "",
    apellidos: "",
    tipoAfiliacion: "",
    regimen: "",
    // Restore from sessionStorage so Ultra theme is instant on page refresh
    isUltra: sessionStorage.getItem('_isUltra') === '1',
    // Ultra dark/light mode toggle — persisted per session
    ultraDarkMode: sessionStorage.getItem('_ultraDark') !== '0', // default dark
  },
  infoPerfilUsuario: {},
};

export const afiliadoSlice = createSlice({
  name: "afiliado",
  initialState,
  reducers: {
    setInfoAfiliado: (state, action) => {
      state.infoAfiliado = action.payload;
    },
    setIsUltra: (state, action) => {
      state.infoAfiliado.isUltra = action.payload;
      // Persist so the theme is instant on next page load
      sessionStorage.setItem('_isUltra', action.payload ? '1' : '0');
    },
    setUltraDarkMode: (state, action) => {
      state.infoAfiliado.ultraDarkMode = action.payload;
      sessionStorage.setItem('_ultraDark', action.payload ? '1' : '0');
    },
    setInfoPerfilUsuario: (state, action) => {
      state.infoPerfilUsuario = action.payload;
    },
  },
});

export const { setInfoAfiliado, setIsUltra, setUltraDarkMode, setInfoPerfilUsuario } = afiliadoSlice.actions;

export default afiliadoSlice.reducer;
